<script setup lang="ts">
import { type NavbarIcon } from './types';

const { icon, defaultColor } = defineProps<{
    icon: NavbarIcon;
    defaultColor?: string;
}>();
</script>

<template>
    <img
        v-if="typeof icon === 'string'"
        v-bind="$attrs"
        :src="icon"
        alt="icon"
    />
    <mr-icon
        v-else-if="'prefix' in icon"
        v-bind="$attrs"
        :icon
        :color="defaultColor"
    />
    <mr-icon
        v-else
        v-bind="$attrs"
        :icon="icon.icon"
        :color="icon.color || defaultColor"
    />
</template>
